import { Module } from 'vuex'
import { RootState } from '../../types'
import { AuthState } from './types'

const { state } = require('./state')
import { actions } from './actions'
import { mutations } from './mutations'
import { getters } from './getters'

export const auth: Module<AuthState, RootState> = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

export default auth
